<template>
  <el-select
    :value="value"
    @input="change"
    clearable
    placeholder="请选择"
    :loading="isLoading"
    class="whole-row">
    <el-option
      v-for="item in options"
      :key="item.code"
      :label="item.text"
      :value="item.code">
    </el-option>
  </el-select>
</template>
<script>
import { SETTING_DICK_FIND_CODE } from '@/store/mutation-types'

export default {
  props:['type','value'],
  data() {
    return {
      isLoading: false,
      options: []
    }
  },
  created() {
    if (this.type) {
      this.isLoading = true
      this.$store.dispatch(SETTING_DICK_FIND_CODE,{ code: this.type }).then(result => {
        this.options = result
        this.isLoading = false
      }, () => {
        this.isLoading = false
      })
    }
  },
  mounted() {
    
  },
  methods: {
    change(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>